import request from '@/utils/request'
/** 订单列表 */
export function fetchList(data) {
  return request({
    url: 'alp/order/list',
    data
  })
}
/** 导出xlsx */
export function outexport(data) {
  return request({
    url: 'alp/offline/export',
    data
  })
}
/** 订单详情 */
export function getDetail(data) {
  return request({
    url: 'alp/order/detail',
    data
  })
}

/** 获取酒店类型 房间类型 */
export function hotelRoomelist(data) {
  return request({
    url: 'alp/order/hotelRoomelist',
    data
  })
}
/** 获取订单来源 **/
export function order_source() {
  return request({
    url: 'alp/company/myList'
  })
}
/** 获取线下订单来源 */
export function validList(data) {
  return request({
    url: 'alp/channel/validList',
    data
  })
}
/** 线下待审核订单 **/
export function waitList(data) {
  return request({
    url: 'alp/offline/waitList',
    data
  })
}
/** 线下待入住订单 **/
export function waitUseList(data) {
  return request({
    url: 'alp/offline/waitUseList',
    data
  })
}
/** 获取房间单价价格 **/
export function room_price(data) {
  return request({
    url: 'alp/order/priceTypeInfo',
    data
  })
}
/** 获取线下价格接口 */
export function offline_price(data) {
  return request({
    url: 'alp/offline/get_offline_price',
    data
  })
}

/** 订单退款 */
export function refundApi(data) {
  return request({
    url: 'alp/order/refund',
    data
  })
}
/** 订单详情入住说明修改 */
export function updateRemark(data) {
  return request({
    url: 'alp/order/updateRemark',
    data
  })
}
/** 订单取消 */
export function cancleApi(data) {
  return request({
    url: 'alp/order/cancel',
    data
  })
}

/** 酒店线下订单取消(同退款功能) */
export function cancleHotel(data) {
  return request({
    url: 'alp/offline_hotel/refund',
    data
  })
}

/** 订单新增 */
export function addOrder(data) {
  return request({
    url: 'alp/order/add',
    data
  })
}

/** 编辑游客信息 */
export function editTouristApi(data) {
  return request({
    url: 'alp/offline_hotel/updateTourist',
    data: {
      tourist: data
    }
  })
}

/** 线下有效订单列表 */
export function offlinelist(data) {
  return request({
    url: 'alp/offline/validList',
    data
  })
}
/** 线下无效订单列表 */
export function invalidList(data) {
  return request({
    url: 'alp/offline/invalidList',
    data
  })
}
/** 线下订单轮循 **/
export function reminder(data) {
  return request({
    url: 'alp/offline/reminder',
    data
  })
}

/** 线下订单详情 */
export function offlineDetail(data) {
  return request({
    url: 'alp/offline/detail',
    data
  })
}

/** 线下订单审核 */
export function examineOrder(data) {
  return request({
    url: 'alp/offline_hotel/checkedOrder',
    data
  })
}

/** 拒绝通过审核 */
export function refusedOrder(data) {
  return request({
    url: 'alp/offline_hotel/refused',
    data
  })
}

/** 线下订单到店确认 */
export function confirmArrival(data) {
  return request({
    url: 'alp/offline/confirmStartTime',
    data
  })
}

/** 离店退房 */
export function checkOut(data) {
  return request({
    url: 'alp/order/checkOut',
    data
  })
}

/** 线下订单备注 */
export function addremark(data) {
  return request({
    url: 'alp/offline/saveLog',
    data
  })
}

/** 酒店数据统计接口 */
export function hotelAll(data) {
  return request({
    url: 'alp/statis/list',
    data
  })
}

/** 酒店按天统计接口 */
export function hotelDay(data) {
  return request({
    url: '/alp/statis/daily_list',
    data
  })
}
/** 酒店统计订单来源 */
export function clientList(data) {
  return request({
    url: '/alp/company/client_list',
    data
  })
}
/** 酒店统计订单查询 */
export function orderList(data) {
  return request({
    url: '/alp/statis/order_list',
    data
  })
}
/** 线下已入住订单列表 */
export function checkedInList(data) {
  return request({
    url: '/alp/offline/checkedInList',
    data
  })
}

/** 客房预订日历 */
export function hotelOrderCalendar(data) {
  return request({
    url: '/alp/offline/hotelOrderCalendar',
    data
  })
}

/** 订房报告 */
export function reservation(data) {
  return request({
    url: '/alp/hotel/reservation',
    data
  })
}

/** 查看其他费用详情 */
export function otherfeelist(data) {
  return request({
    url: '/alp/hotel/otherfeelist',
    data
  })
}

/** 新增其他费用下拉选择框的数据 */
export function allproduct(data) {
  return request({
    url: '/alp/hotel/allproduct',
    data
  })
}

/** 新增费用提交按钮 */
export function addotherfee(data) {
  return request({
    url: '/alp/hotel/addotherfee',
    data
  })
}

/** 房间生产报告 */
export function productionreport(data) {
  return request({
    url: '/alp/hotel/productionreport',
    data
  })
}

/** 客房收入报告 */
export function incomereport(data) {
  return request({
    url: '/alp/hotel/incomereport',
    data
  })
}

/** 预定清单和报告 */
export function memberList(data) {
  return request({
    url: '/alp/offline/memberList',
    data
  })
}

/** 预定清单和报告詳情 */
export function memberinfo(data) {
  return request({
    url: '/alp/hotel/memberinfo',
    data
  })
}
